import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { CreatePathAPI } from "../../../API/PathAPI";
import { IResponseProps } from "../../../Interfaces/IResponseProps";

interface ICreatePathComponentProps {
    show: boolean,
    handleClose: () => void,
    toggleLoading: (data: boolean) => void,
    companyId: string,
    pathMain: string,
    path: string,
    userEmail: string,
    setPathsHasChanged: React.Dispatch<React.SetStateAction<boolean>>
}

const CreatePathComponent = (props: ICreatePathComponentProps) => {
    const [pathName, setPathName] = useState<string>("");

    const createPath = async () => {
        try {
            props.toggleLoading(true);

            await CreatePathAPI(pathName, props.companyId, props.pathMain, props.path, props.userEmail).then((resp: IResponseProps) => {
                if(resp.statusCode == 200) {
                    toast.success(`pasta ${pathName} criada com sucesso!`);
                    props.setPathsHasChanged(true);
                    setPathName("");
                    props.handleClose();
                }
            }).finally(() => props.toggleLoading(false));
        } catch(error: any) {
            toast.error(error);
            props.toggleLoading(false);
        }
    }

    return (
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Criar Subpasta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label className="required">Nome da pasta:</label>
                <input required value={pathName} onChange={(e) => setPathName(e.target.value)} className="w-100 form-control mt-1" />
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={pathName == ""} className='btn btn-primary w-100' onClick={createPath}>
                    Criar Pasta
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CreatePathComponent;